// Signup.jsx (converted from signup.html)
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signup as registerUser } from '../services/ChatbotService';


const Signup = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    const response = await registerUser(username, password);
    if (response.status === 'success') {
      navigate('/login');
    } else {
      setError(response.message || 'Signup failed');
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="card p-4" style={{ minWidth: '320px', maxWidth: '400px', border: '1px solid #7303fc', backgroundColor: '#4d1e87' }}>
        <h4 className="mb-3 text-center text-light">Sign Up</h4>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSignup}>
          <div className="mb-3">
            <label className="form-label text-light">Username</label>
            <input type="text" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} required />
          </div>
          <div className="mb-3">
            <label className="form-label text-light">Password</label>
            <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <div className="d-grid">
            <button type="submit" className="btn btn-custom">Sign Up</button>
          </div>
        </form>
        <p className="mt-3 text-center text-light">Already have an account? <a href="/login" className="link-light">Login</a></p>
      </div>
    </div>
  );
};

export default Signup;
